module.exports = __webpack_public_path__ + "img/estj-selected.7fb5a090.png";